import { render, staticRenderFns } from "./voiceMgr.vue?vue&type=template&id=4939c7a4&scoped=true&"
import script from "./voiceMgr.vue?vue&type=script&lang=js&"
export * from "./voiceMgr.vue?vue&type=script&lang=js&"
import style0 from "./voiceMgr.vue?vue&type=style&index=0&id=4939c7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939c7a4",
  null
  
)

export default component.exports